import { Typography } from "@mui/material";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

import { ERole } from "../../../@types";
import { useAccount } from "../../../hooks/useAccount";
import {
	useMyLearningProgress,
	useMyLearningProgressInit,
} from "../../../hooks/useMyLearningProgress";
import { useMyServices, useMyServicesInit } from "../../../hooks/useMyServices";
import { usePaymentRequestInit } from "../../../hooks/usePaymentRequest";
import { useSchedule, useScheduleInit } from "../../../hooks/useSchedule";
import {
	useTeachingPolicy,
	useTeachingPolicyInit,
} from "../../../hooks/useTeachingPolicy";
import { Container } from "../../common/Container/Container";
import { Availability } from "./components/Availability/Availability";
import { Dashboard } from "./components/Dashboard/Dashboard";
import { MyProgress } from "./components/MyProgress/MyProgress";
import { MyServices } from "./components/MyServices/MyServices";
import { Payments } from "./components/Payments/Payments";
import { Scheduler } from "./components/Scheduler/Scheduler";

import "./training.scss";

export function Home() {
	const { account } = useAccount();
	const { loading: loadingMyLearningProgress, summaries } =
		useMyLearningProgress();
	const { loading: loadingMyServices } = useMyServices();
	const { loading: loadingTeachingPolicy } = useTeachingPolicy();
	const { loading: loadingSchedule } = useSchedule();

	const loading =
		loadingMyLearningProgress ||
		loadingMyServices ||
		loadingTeachingPolicy ||
		loadingSchedule;

	useMyLearningProgressInit();
	useMyServicesInit();
	useTeachingPolicyInit();
	useScheduleInit();
	usePaymentRequestInit();
	const location = useLocation();
	const isDashboard = location.pathname.startsWith("/training/dashboard");
	const isCalendar = location.pathname.startsWith("/training/calendar");
	const isAvailability = location.pathname.startsWith("/training/availability");
	const isMyServices = location.pathname.startsWith("/training/my-services");
	const isMyProgress = location.pathname.startsWith("/training/my-progress");
	const isPayments = location.pathname.startsWith("/training/payments");

	if (!account) {
		return null;
	}

	return (
		<Container className="training-container" loading={loading} noFooter>
			<div className="training-content-container">
				<div className="left-column">
					<div className="item-separator-small" />
					<Link
						to="/training/dashboard"
						className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isDashboard,
							})}>
							Dashboard
						</Typography>
					</Link>
					{account.role === ERole.INSTRUCTOR && (
						<Link
							to="/training/my-services"
							className="no-underline-link black-text">
							<Typography
								className={classNames("menu-button normal-text bold", {
									selected: isMyServices,
								})}>
								My Services
							</Typography>
						</Link>
					)}
					{(account.role === ERole.STUDENT || summaries.length > 0) && (
						<Link
							to="/training/my-progress"
							className="no-underline-link black-text">
							<Typography
								className={classNames("menu-button normal-text bold", {
									selected: isMyProgress,
								})}>
								My Progress
							</Typography>
						</Link>
					)}
					<Link
						to="/training/calendar"
						className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isCalendar,
							})}>
							Calendar
						</Typography>
					</Link>
					{account.role === ERole.INSTRUCTOR && (
						<Link
							to="/training/availability"
							className="no-underline-link black-text">
							<Typography
								className={classNames("menu-button normal-text bold", {
									selected: isAvailability,
								})}>
								Availability
							</Typography>
						</Link>
					)}
					<Link
						to="/training/payments"
						className="no-underline-link black-text">
						<Typography
							className={classNames("menu-button normal-text bold", {
								selected: isPayments,
							})}>
							Payments
						</Typography>
					</Link>
				</div>
				<div className="right-column">
					{isDashboard && <Dashboard />}
					{isCalendar && <Scheduler />}
					{isAvailability && <Availability />}
					{isMyServices && <MyServices />}
					{isMyProgress && <MyProgress />}
					{isPayments && <Payments />}
				</div>
			</div>
		</Container>
	);
}
